import * as React from "react";
import { Button } from "@ogt/ui";

type Props = {
  map: google.maps.Map | null;
};

export default function MapControllerButton({ map }: Props) {
  const [mapType, setMapType] = React.useState<string>(
    google.maps.MapTypeId.ROADMAP
  );

  React.useEffect(() => {
    if (!map) return;

    const update = () => {
      const nextMapType = map.getMapTypeId();

      if (nextMapType) {
        setMapType(nextMapType);
      }
    };

    update();

    const listener = map.addListener("maptypeid_changed", update);

    return () => {
      listener.remove();
    };
  }, [map]);

  if (!map) return null;

  const isRoadmap = mapType === google.maps.MapTypeId.ROADMAP;
  const isSatellite = mapType === google.maps.MapTypeId.SATELLITE;

  return (
    <div className="absolute right-3 top-3 z-10 flex gap-1 bg-white rounded-sm  px-2 py-1.5 ">
      <Button
        type="button"
        variant="secondary"
        size="small"
        activated={isRoadmap}
        aria-pressed={isRoadmap}
        onClick={() => map.setMapTypeId(google.maps.MapTypeId.ROADMAP)}
      >
        Karta
      </Button>

      <Button
        type="button"
        variant="secondary"
        size="small"
        activated={isSatellite}
        aria-pressed={isSatellite}
        onClick={() => map.setMapTypeId(google.maps.MapTypeId.SATELLITE)}
      >
        Satellit
      </Button>
    </div>
  );
}
